import { render, staticRenderFns } from "./HandleRoleTabGeneral.vue?vue&type=template&id=6ff76cb6"
import script from "./HandleRoleTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleRoleTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleRoleTabGeneral.vue?vue&type=style&index=0&id=6ff76cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports